<template>
  <div
    :class="badgeClasses"
    data-cy="ds-badge"
    role="status"
    :aria-label="props.ariaLabel"
  >
    <DSIcon
      v-if="props.icon"
      :size="iconSize"
      :icon="props.icon"
    />
    <span
      v-if="props.text"
      :class="DS_BADGE_CLASSES.Text"
      data-cy="ds-badge__text"
    >
      {{ props.text }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  DS_BADGE_CLASSES,
  DS_BADGE_STATE_TO_CLASS_MAP,
} from "@/src/design_system/data_display/badge/constants/classes";
import { DS_BADGE_ICON_SIZE_MAP } from "@/src/design_system/data_display/badge/constants/iconSize";
import { DSBadgeContentProps } from "@/src/design_system/data_display/badge/types/props";
import { useStateClasses } from "@/src/design_system/shared/composables/useStateClasses";
import DSIcon from "@/src/design_system/primitives/icon/components/DSIcon.vue";

const props = defineProps<DSBadgeContentProps>();

const { stateClasses } = useStateClasses(props);

const badgeClasses = computed(() => {
  const classes: (string | Record<string, boolean>)[] = [DS_BADGE_CLASSES.Root, stateClasses.value];

  const stateClass = DS_BADGE_STATE_TO_CLASS_MAP[props.state];
  if (stateClass) {
    classes.push(stateClass);
  }

  const sizeClass = `${DS_BADGE_CLASSES.Root}--${props.size}`;
  classes.push(sizeClass);

  return classes;
});

const iconSize = computed(() => {
  return DS_BADGE_ICON_SIZE_MAP[props.size];
});
</script>
